export default __webpack_public_path__ + "static/media/billy_search.9231704a.png";